import { HttpContextToken } from '@angular/common/http'

// Marks a request as originating from the org API Keys documentation
// "Try it" console — authenticated with a user-entered org API key, not
// the caller's own session. authInterceptor reads this to skip its
// session-teardown-on-401 handling for these requests: a wrong/invalid
// org API key producing a 401 must not log the real session out.
export const DOC_PLAYGROUND_REQUEST = new HttpContextToken<boolean>(() => false)
